module.exports = __webpack_public_path__ + "img/pci-dss-compliant.780f5b05.png";